
import { useL10n } from "@ews/react-localization-context";
import { IonIcon } from "@ionic/react";
import { caretDown, caretUp } from "ionicons/icons";
import listStyle from "../../List.module.scss";
import { HeaderItemProps, HeaderOption, ListProps, ResponsiveChooice } from "../../types";
import { ResponsiveContainer } from "../Row/ResponsiveContainer";
import { RowProps } from "../Row/Row";

type HeaderContainerProps = Pick<ListProps, "headers" | "onSort" | "sort"> & Pick<RowProps, "hasMenu">;

export const settingsHeader: HeaderOption = {
    both: true, title: "", key: "", className: `${listStyle.headerSettings}`, option: { noSort: true }
};
const Header: React.FC<HeaderItemProps> = ({ item, onClick, icon, className }) =>
{
    const { translate: t } = useL10n();

    let choice: ResponsiveChooice = 'desktop';

    if (item.breakpoint) choice = 'breakpoint';
    else if (item.desktop) choice = 'desktop';
    else if (item.mobile) choice = 'mobile';
    else choice = 'both';

    const Container = ResponsiveContainer(choice, item.breakpoint || 0, item.up);
    return <Container>
        <div className={`${className} ${listStyle.col} ${!item?.option?.noSort ? listStyle.pointer : ''}`}
            onClick={() =>
            {
                if (onClick) onClick(item.key);
            }}
        >
            {t(item.title)}
            {icon ? <IonIcon icon={icon}></IonIcon> : null}
        </div>

    </Container>;
};


export const HeaderContainer: React.FC<HeaderContainerProps> = ({ headers, onSort, sort, hasMenu }) =>
{

    return <>
        {hasMenu ? <Header className={`${settingsHeader.className || ""}`} item={settingsHeader} ></Header> : null}
        {headers.map((head, index) =>
        {
            return head.option && head.option?.noSort ?
                <Header className={`${head?.className || ""}`} key={index} item={head}></Header>
                :
                <Header className={head?.className} key={index} onClick={(key: string) =>
                {
                    if (onSort && "subEntity" in head) {
                        const direction = sort?.key === head.subEntity ? (sort?.direction === "ASC" ? "DESC" : "ASC") : "ASC";
                        onSort(head.subEntity, direction);
                    }
                    else if (onSort) {

                        const direction = sort?.key === head.key ? (sort.direction === "ASC" ? "DESC" : "ASC") : "ASC";
                        onSort(key, direction);
                    };

                }
                }
                    item={head}
                    icon={
                        (sort?.key === head["subEntity" in head ? "subEntity" : "key"] &&
                            sort?.direction) ? (sort.direction === "ASC" ? caretUp : caretDown) : undefined}
                ></Header>;
        })}
    </>;

};